import Insight from "../insightClass";
import React from "react";
import { insight30Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight056 = new Insight(
  "25 July 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight30Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-07-25)",
  "",
  `The UK government has set new AR7 offshore wind CfD strike price caps at £113/MWh for fixed-bottom and £271/MWh for floating (2024 prices). The move addresses inflation and supply chain pressures, boosting project viability and fostering auction competitiveness.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-07-25)</h1>
    <h2></h2>
    <p className="article-date">25 July 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. London raises AR7 strike price caps</h3>
    <p>
      The UK government has set new AR7 offshore wind CfD strike price caps at
      £113/MWh for fixed-bottom and £271/MWh for floating (2024 prices). The
      move addresses inflation and supply chain pressures, boosting project
      viability and fostering auction competitiveness.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The price increase restores market confidence, especially as floating wind
      remains in a high-cost phase. Fixed-bottom wind benefits from scale and
      local supply chain efficiencies. Developers should secure inflation
      protection in contracts to mitigate future cost risks.
    </p>
    <h3>2. Iberdrola eyes UK, US networks investment drive</h3>
    <p>
      Iberdrola has announced a €5billion capital raise to boost grid upgrades
      in the UK and US, ensuring efficient clean energy transmission and
      integration, while accelerating offshore wind build-out and network
      synergy.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Grid capacity is becoming a bottleneck for offshore wind growth. By
      investing in regulated networks, Iberdrola secures stable returns while
      enhancing offtake capability for its wind farms. For developers, grid
      alignment will be crucial for optimizing project returns.
    </p>
    <h3>3. CorPower Ocean wins €40m for VianaWave</h3>
    <p>
      Sweden’s CorPower Ocean has secured €40million from the EU Innovation Fund
      to deliver the 10MW VianaWave wave energy demonstration project in
      Portugal, advancing commercialisation of its WaveSpring technology.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Commercialising wave energy could diversify offshore renewable portfolios.
      If successfully demonstrated, hybrid projects combining wave devices with
      wind turbines could boost capacity factors. However, durability and cost
      competitiveness remain key hurdles for scaling deployment in harsh ocean
      environments.
    </p>
    <h3>4. Fortum to buy 4.4GW Finnish development portfolio</h3>
    <p>
      Finnish utility Fortum will acquire a 4.4GW onshore wind development
      portfolio from ABO Energy, bolstering its Nordic renewable footprint and
      strengthening regional energy diversification.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Though onshore, this acquisition strengthens Fortum’s renewable strategy.
      Its synergy with hydro and nuclear assets can help balance the
      intermittency of future offshore wind projects, enhancing grid stability
      and flexibility across the Nordic market.
    </p>
    <h3>5. Equinor books $955m hit on US offshore wind</h3>
    <p>
      Norway’s Equinor has booked a $955million impairment charge in Q2 2025 on
      its US offshore wind portfolio due to supply chain delays, inflation, and
      regulatory uncertainties impacting project economics.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This highlights systemic risks in the US offshore wind sector. Future
      contracts must embed inflation clauses and regulatory safeguards.
      Diversified investments and flexible procurement strategies will be
      critical to de-risking project pipelines.
    </p>
    <h3>6. UN chief warns fossil fuels ‘running out of road’</h3>
    <p>
      UN Secretary-General António Guterres warned that the fossil fuel era is
      “running out of road,” urging governments to stop greenwashing and ramp up
      policy and investment support for renewables to accelerate the global
      energy transition.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Such high-level statements boost investor confidence in offshore wind and
      wind turbines. However, faster permitting, supply chain expansion, and
      grid readiness are essential to convert policy momentum into tangible
      project returns.
    </p>
    <h3>7. New crew transfer vessel delivered for Korea’s offshore wind</h3>
    <p>
      South Korea’s Yeosu Ocean Co. has taken delivery of a 27m aluminium-hulled
      crew transfer vessel, Ventus Camellia, featuring efficient propulsion and
      reduced emissions, to support the fast-growing Korean offshore wind
      market.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Crew transfer vessel capability directly impacts wind farm uptime and IRR.
      As Asian markets scale, localised supply chains and efficient vessel
      designs will be vital for maximising operational performance and financial
      outcomes.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
